<template>
  <div id="app">
     <!-- 标题 -->
    <!-- <HeaderView></HeaderView> 启用吸顶方式，精益旧的网站标题暂时不用-->
    <!-- 导航菜单 -->
    <HearderMenu></HearderMenu>
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view/>  
    <FooterView></FooterView>
  </div>
</template>
<script>
 //import HeaderView from "./views/HeaderView"
 import HearderMenu from "./views/HearderMenu.vue"
 import FooterView from "./views/FooterView.vue"
 export default {
 components: {
   // HeaderView,
    HearderMenu,
    FooterView
  }
}
</script>
<style>
 html{

   overflow-x: hidden; 
 }
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
